




















































import { Vue, Prop, Component } from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import toCurrency from '@/shared/directive/toCurrency';
import Headers from './summary-table-headers.json';

@Component({
  filters: {
    dayMonthYear(date: string): string {
      if (date === undefined || date === '' || date === ' ' || date === null) return '-';
      return DateFormat.timestampToLocal(date.substr(0, 10));
    },
    toCurrency,
  },
})
export default class BillingInfoContentSummaryTable extends Vue {
  @Prop({
    required: true,
  })
  items!: any;

  headers: any = Headers;
}
